document.addEventListener("DOMContentLoaded", () => {
    const phoneEl = document.querySelector(".callback-section__number-text");

    if (!phoneEl) return;

    const outboundRegion = window.sessionStorage.getItem('outboundRegion');
    outboundRegion && (phoneEl.innerHTML = phoneEl.dataset[`phone${outboundRegion}`]);
});
